 <app-header *ngIf="isHeader"></app-header>
<alert></alert>
<app-popup #popup></app-popup>
<ngx-spinner [type]="'ball-spin'"></ngx-spinner>
<app-button-group *ngIf="!hideButtons"></app-button-group>
<router-outlet></router-outlet>
<app-footer *ngIf="isFooter"></app-footer>